var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('question',{attrs:{"text":_vm.$t(_vm.item.text)}}),_c('v-select',{attrs:{"appendToBody":"","placeholder":_vm.$t('INTERACTION_BASE_UI_DROPDOWN_SELECT_COUNTRY'),"clearable":false,"options":_vm.options},on:{"option:selected":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }